export const REGION_IDS: Record<string, string> = {
  "Oceania": "91000010",
  "EMEA": "91000007",
  "DACH": "91000006",
  "North America": "102221843",
  "Benelux": "91000005",
  "APJ": "91000004",
  "APAC": "91000003",
  "Asia": "102393603",
  "Nordics": "91000009",
  "MENA": "91000008",
  "Europe": "100506914",
  "Africa": "103537801",
  "South America": "104514572",
};

export const getRegionId = (name: string): string | undefined => {
  const id = REGION_IDS[name.trim()];
  if (!id) {
    console.log(`ℹ️  No LinkedIn ID found for region: "${name}" - using text search fallback`);
  }
  return id;
};

